export const InventoryFormTypes = Object.freeze({
	Inventory: 1,
	RemoteUser: 2,
	SteadyState: 3,
});
